import { Controller } from "stimulus";
import { rebind } from "../rebind";
import { railsAjax } from "../../services/rails-ajax";
export default class extends Controller {
  //
  // life cycle
  //
  initialize() {
  }

  //
  // target
  //
  static targets = [
    'data',
    'index',
  ]

  //
  // data
  //
  data() {
    const $dataTarget= $(this.dataTarget);
    const scheduleType = $dataTarget.data('schedule-type');
    const datenum      = $dataTarget.data('datenum');
    return {
      scheduleType: scheduleType,
      datenum: datenum
    };
  }
  prevMonth() {
    this.apiIndexSchedule('prev');
  }
  nextMonth() {
    this.apiIndexSchedule('next');
  }

  //
  // private
  //
  apiIndexSchedule(page = "") {
    const data = this.data();
    railsAjax({
      type: "GET",
      url: `/services/calendar/?schedule_type=${data.scheduleType}&datenum=${data.datenum}&page=${page}`,
      done: (response) => {
        this.indexTarget.innerHTML = response;
        rebind(this.indexTarget);
        $('#modal').modal('hide');
      }
    });
  }
}
